module.exports = __webpack_public_path__ + "static/marker7-52c116d2071ba756db2331294513d95f.png";